const HUBSPOT_PORTAL_ID = "2859033";
const HUBSPOT_FORM_ID = "512abe7b-fb1c-425c-b325-11fa5195d5dc";
const HUBSPOT_NEWSLETTER_SUBMIT_URL = `https://api.hsforms.com/submissions/v3/integration/submit/${HUBSPOT_PORTAL_ID}/${HUBSPOT_FORM_ID}`;

class NewsletterForm {
  constructor(root) {
    this.root = root;
    this.form = root.querySelector(".newsletter__form");
    this.field = root.querySelector(".newsletter__field");
    this.input = root.querySelector(".newsletter__field input");
    this.fieldMessage = root.querySelector(".newsletter__field-message");
    this.fieldError = root.querySelector(".newsletter__field-error");
    this.formError = root.querySelector(".newsletter__form-error");
    this.submit = root.querySelector(".newsletter__submit");
    this.submitUrl =
      (this.form && this.form.dataset.hubspotSubmitUrl) ||
      HUBSPOT_NEWSLETTER_SUBMIT_URL;

    if (!this.form || !this.input || !this.submit) return;

    this.isSubmitting = false;
    this.isResolved = false;

    this.form.addEventListener("submit", (e) => this.handleSubmit(e));
    this.input.addEventListener("input", () => this.clearFieldError());
  }

  isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  getCookie(name) {
    const match = document.cookie.match(
      new RegExp(
        `(?:^|; )${name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1")}=([^;]*)`,
      ),
    );
    return match ? decodeURIComponent(match[1]) : "";
  }

  clearFieldError() {
    if (!this.field || !this.field.classList.contains("is-error")) return;
    this.field.classList.remove("is-error");
  }

  showFieldError(message) {
    if (this.field) {
      this.field.classList.add("is-error");
    }
    if (this.fieldError && message) {
      this.fieldError.textContent = message;
    }
    this.input.focus();
  }

  lockButtonSize() {
    const rect = this.submit.getBoundingClientRect();
    this.submit.style.width = `${rect.width}px`;
    this.submit.style.height = `${rect.height}px`;
  }

  setSubmitting() {
    this.isSubmitting = true;
    this.form.classList.remove("is-error");
    this.lockButtonSize();
    this.submit.classList.add("is-loading");
    this.submit.classList.remove("is-success");
    this.submit.disabled = true;
    this.input.disabled = true;
    this.submit.setAttribute("aria-busy", "true");
  }

  showSuccess() {
    this.isSubmitting = false;
    this.isResolved = true;
    this.submit.classList.remove("is-loading");
    this.submit.classList.add("is-success");
    this.submit.style.width = "";
    this.submit.style.height = "";
    this.submit.removeAttribute("aria-busy");
    this.submit.setAttribute("aria-label", "Subscribed");

    if (this.fieldMessage) {
      // Keep "You're in." / "We'll be in touch." as solid units when wrapping.
      this.fieldMessage.textContent = "You're in. We'll be in touch.";
    }
    this.field.classList.add("is-resolved");
  }

  showError(message) {
    this.isSubmitting = false;
    this.submit.classList.remove("is-loading", "is-success");
    this.submit.style.width = "";
    this.submit.style.height = "";
    this.submit.disabled = false;
    this.input.disabled = false;
    this.submit.removeAttribute("aria-busy");

    this.form.classList.add("is-error");
    if (this.formError && message) {
      this.formError.textContent = message;
    }

    window.setTimeout(() => {
      this.form.classList.remove("is-error");
    }, 2500);
  }

  buildPayload(email) {
    const context = {
      pageUri: window.location.href,
      pageName: document.title,
    };
    const hutk = this.getCookie("hubspotutk");
    if (hutk) {
      context.hutk = hutk;
    }

    return {
      fields: [{ name: "email", value: email }],
      context,
    };
  }

  async submitToHubSpot(email) {
    const response = await fetch(this.submitUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(this.buildPayload(email)),
      credentials: "omit",
    });

    if (!response.ok) {
      let detail = "";
      try {
        detail = await response.text();
      } catch {
        detail = "";
      }
      throw new Error(detail || `HubSpot submit failed (${response.status})`);
    }

    return response;
  }

  async handleSubmit(e) {
    e.preventDefault();

    if (this.isSubmitting || this.isResolved) {
      return;
    }

    const email = this.input.value.trim();
    if (!this.isValidEmail(email)) {
      this.showFieldError(
        (this.fieldError && this.fieldError.textContent) ||
          "Please enter a valid email.",
      );
      return;
    }

    this.clearFieldError();
    this.setSubmitting();

    try {
      await this.submitToHubSpot(email);
      this.showSuccess();
    } catch (error) {
      console.error("Newsletter HubSpot submit failed:", error);
      const fallback =
        (this.formError && this.formError.textContent) ||
        "Something went wrong. Please try again.";
      this.showError(fallback);
    }
  }
}

document
  .querySelectorAll(".wrg.newsletter")
  .forEach((root) => new NewsletterForm(root));
